import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ENV } from 'utils/env';

export const innovorderApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: ENV.API_URL,
    }),
    endpoints: () => ({}),
    tagTypes: ['Brand'],
});
